// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// TST

export const environment = {
  production: false,
  showLogoutHeader: true,
  baseServerUrl: '',
  stargatetokenUrl: 'https://api-stg.uhg.com/oauth2/token',
  azureApiClientId: 'fa65899e-311c-4c55-898f-245cf757a2d0',
  azureApiClientSecret: 'iWpYEH460hxHvgrFRcVsfDv78UMJevbi6Gz',
  starGateUrl: 'https://api-stg.uhg.com/api/cloud/api-management',
  backedBaseUrl:'https://api-stg.uhg.com/api/cloud/api-management',
  accessTokenServerUrl: 'https://api-stg.uhg.com/api/cloud/api-management/sp-auth-service-tst/v1',
  //hcpCredsUrl: 'http://submissions-auth-service-tst-service:8080/api/submissions-auth-service/security/oauth2/hcpCredentials',
  maintenanceBaseUrl:"https://sp-edps-maintenance-dev.hcck8s-ctc.optum.com/api/submissions-portal/edps/maintenance", //not used
  oauthEndpoint: '/security/oauth2/generateAccessToken',
  userEndPoint: '/v1/userprincipals/',

  hccValuationBaseUrl: 'https://api-stg.uhg.com/api/cloud/api-management/hcc-valuation-tst/v1',

  providerSearchEndpoint: 'https://sub-provider-search-api-tst-azure.optum.com',
  providerSearchGatewayEndpoint: '',
  providerSearchMetadataEndpoint: 'https://sub-provider-search-api-tst-azure.optum.com/v1/metadata',
  providerSearchFeatureEnabled: true,
  providerSearchRoutingMode: 'direct',

  billingProviderAgentEndpoint: 'https://api-stg.uhg.com/api/cloud/api-management/err-corr-agent-tst/v1/v1/billing-provider-nppes/suggestions',
  billingProviderAgentGatewayEndpoint: 'https://api-stg.uhg.com/api/cloud/api-management/err-corr-agent-tst/v1/v1/billing-provider-nppes/suggestions',
  billingProviderAgentMetadataEndpoint: 'https://api-stg.uhg.com/api/cloud/api-management/err-corr-agent-tst/v1/v1/metadata',
  billingProviderAgentFeatureEnabled: true,
  billingProviderAgentRoutingMode: 'gateway',

  logoutUrl: 'https://identity.nonprod.onehealthcareid.com/oidc/logout?id_token_hint=',
  pingfederateRedirectUrl: 'https://submissions-portal-tst.optum.com/optumid',
  pingfederateLoginUrl: 'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=edps34525&response_type=code&scope=openid+profile+email+phone&redirect_uri=',

  reportingServiceBaseUrlSuffix: "/sp-edps-claims-tst",
  reportingServiceBaseCRRUrlSuffix: "/sp-edps-asm-data-tst/v1",
  exportServiceBaseUrlSuffix: "/sp-data-export-tst",
  correctionServiceBaseUrlSuffix: "/sp-error-correction-tst/v1",
  maintenanceServiceBaseUrlSuffix: "/sp-edps-maintenance-tst",
};
